import { render } from "./ScripturePicker.vue?vue&type=template&id=1569178c&scoped=true"
import script from "./ScripturePicker.vue?vue&type=script&lang=ts"
export * from "./ScripturePicker.vue?vue&type=script&lang=ts"

import "./ScripturePicker.vue?vue&type=style&index=0&id=1569178c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1569178c"

export default script